import React from "react";
import { Div, Row, Col, Input } from "atomize";
import { FindButton } from "../atoms/buttons";
import HeaderLottie from "./headerLottie";
import { Text } from "atomize";
import { SearchIcon } from "../atoms/icons";

const Heading = () => {
  return (
    <div>
      <Row align={{ md: "flex-end" }}>
        <Col size={{ xs: 12, md: 6 }}>
          <Div p="1rem">
            <Text className="mb-3" textSize="48px" textWeight="700">
              Your Bike <br />
              Electric Update
            </Text>
            <Text
              className="mb-5"
              textSize="21px"
              textWeight="300"
              textColor="#7D7987"
              style={{ lineHeight: "32px" }}
            >
              Dummy text progressive, and affordable
              <br />
              healthcare, accessible on mobile and online
              <br />
              for everyone
            </Text>
            <Row>
              <Col>
                <Div
                  d="flex"
                  bg="#FFFFFF"
                  border="1px solid"
                  borderColor="#C2CFE0"
                  p="0.5rem"
                  rounded="100px"
                  justify="space-between"
                >
                  <Div d="flex" align="center">
                    <SearchIcon />
                    <Input
                      placeholder="Search Bike or anything"
                      h="2.5rem"
                      border="none"
                    />
                  </Div>
                  <FindButton />
                </Div>
              </Col>
            </Row>
          </Div>
        </Col>
        <Col size={{ xs: 12, md: 6 }}>
          <Div>
            <HeaderLottie />
          </Div>
        </Col>
      </Row>
    </div>
  );
};

export default Heading;
